import { PAGE_HOME, GET_ALL_PAGES_WITH_SLUG_QUERY, PAGE_BY_SLUG } from './queries/pages'
import { sendNwReq } from './index'
import { sendNwReqWithAuth } from './network'
import { SITENAME } from '../utils/siteConfig'

// Home/Index Page
async function fetchPageData(pageId, pageIdType, preview) {
  const queryVariables = {
    id: pageId,
    idType: pageIdType,
  }

  const responseData = preview
    ? await sendNwReqWithAuth(PAGE_HOME, queryVariables)
    : await sendNwReq(PAGE_HOME, queryVariables)

  return { pageData: responseData?.data?.page || {} }
}

async function fetchPageByGql(gqlQuery, params, preview) {
  const responseData = preview
    ? await sendNwReqWithAuth(gqlQuery, params)
    : await sendNwReq(gqlQuery, params)

  const pageData = responseData?.data?.pageBy || responseData?.data || {}

  return pageData
}

// preview mode
const getPageBySlug = async slug => {
  if (!slug) return

  const variables = { slug: `${slug}` }
  const response = await sendNwReqWithAuth(PAGE_BY_SLUG, variables)
  const page = response?.data?.page || {}

  return page
}

/**
 * Fetch All Content Builder Pages
 * @returns {Array} Object {id, slug}
 */
const getAllBuilderPages = async () => {
  const response = await sendNwReq(GET_ALL_PAGES_WITH_SLUG_QUERY, {
    term: SITENAME,
  })

  const allPages = await response?.data?.pages?.nodes
  const filteredPages =
    allPages?.filter(page => page?.template?.templateName == 'Page Content Builder') || []

  return filteredPages
}

export { fetchPageData, fetchPageByGql, getAllBuilderPages, getPageBySlug }
